import { render } from "./cupom.vue?vue&type=template&id=13f21a22&scoped=true"
import script from "./cupom.vue?vue&type=script&lang=js"
export * from "./cupom.vue?vue&type=script&lang=js"

import "./cupom.vue?vue&type=style&index=0&id=13f21a22&scoped=true&lang=css"
import "./cupom.vue?vue&type=style&index=1&id=13f21a22&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f21a22"]])

export default __exports__